module.exports = __webpack_public_path__ + "assets/2ed9b9e579600f6c8bd6df01883ee4cb.mp3";